import Footer from "./Footer";
import ContactForm from "./ContactForm";

function ContactFooter() {

  return (
    <div className="flex flex-col w-full bg-brand-silicon-white font-pretendard text-black pt-10">
      <div className="flex-grow w-full my-10">
        <ContactForm />
      </div>
      <Footer />
    </div>
  );
}

export default ContactFooter;
